import { render } from "./HomeMenu.vue?vue&type=template&id=33786484&scoped=true&ts=true"
import script from "./HomeMenu.vue?vue&type=script&lang=ts"
export * from "./HomeMenu.vue?vue&type=script&lang=ts"

import "./HomeMenu.vue?vue&type=style&index=0&id=33786484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33786484"]])

export default __exports__